import { LoadableAfterPaint } from '@confluence/loadable';

export const NavigationBannerLoadable = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NavigationBanner" */ '../../src/ui/side-nav-banner/NavigationBanner.tsx'
			)
		).AdminUpsellNavigationBanner,
});
